<h6 class="center">{{ qualification.qualification_name }}</h6>
<div class="clearfix"></div>
<div class="row">
  <div class="col-md-12">
    <button
      *ngIf="quotaFlags.census"
      type="button"
      class="btn btn-default btn-link btn-xs add-quotas"
      (click)="applySearchLocationCensus()"
      [disabled]="isQlcLiveSurvey"
    >
      Add Census Quotas
    </button>
    <button
      *ngIf="quotaFlags.add"
      type="button"
      class="btn btn-default btn-link btn-xs add-quotas"
      (click)="openSearchLocationQuotaModal()"
      [disabled]="isQlcLiveSurvey"
    >
      Add Quotas
    </button>
    <button
      *ngIf="quotaFlags.add"
      type="button"
      class="btn btn-default btn-link btn-xs add-quotas"
      (click)="addAllQuotas()"
      [disabled]="isQlcLiveSurvey"
    >
      Select All Options
    </button>
    <button
      *ngIf="quotaFlags.edit"
      type="button"
      class="btn btn-default btn-link btn-xs add-quotas"
      (click)="openSearchLocationQuotaModal()"
    >
      Edit Quotas
    </button>
    <button
      *ngIf="quotaFlags.delete"
      type="button"
      class="btn btn-default btn-link btn-xs add-quotas"
      (click)="deleteSearchLocationQuotas()"
      [disabled]="isQlcLiveSurvey"
    >
      Delete Quotas
    </button>
  </div>
</div>
<div class="row">
  <header class="flex-container flex-center">
    <div class="center search-bar-div">
      <i class="fa fa-search icon-pos"></i>
      <input
        id="searchKey"
        placeholder="Start Typing (min 3 characters)..."
        (click)="openDropDown()"
        class="search-bar"
        autocomplete="off"
        [(ngModel)]="searchKeyword"
        (keyup)="onSearchKeyUp(searchKey.value)"
        #searchKey
      />
      <ps-ui-ellipsis-loader
        class="bouncing-loader"
        [show]="showLoaderForSelectLocation"
      >
      </ps-ui-ellipsis-loader>
      <div>
        <div class="clearfix"></div>
        <div *ngIf="showDropDown" class="search-drop-down center">
          <div
            (click)="selectLocation(location)"
            class="search-results"
            *ngFor="let location of locationData"
          >
            <a>
              {{ location.name }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </header>
</div>
<ul class="list-inline list-unstyled center selected-location-ul">
  <ng-container *ngFor="let item of qualification.data; let i = index">
    <li
      class="selected-location-list"
      *ngIf="item.selected"
      [attr.data-index]="i"
    >
      {{ item.name }}
      <a (click)="removeSelectedLocation(item)">x</a>
    </li>
  </ng-container>
</ul>
